import { render, staticRenderFns } from "./teamSharing.vue?vue&type=template&id=0c0415a4&"
import script from "./teamSharing.vue?vue&type=script&lang=js&"
export * from "./teamSharing.vue?vue&type=script&lang=js&"
import style0 from "./teamSharing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports